import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import * as jwt_decode from 'jwt-decode';
import { BehaviorSubject, Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

export const TOKEN_NAME = 'token';

@Injectable()
export class AuthService {

  loggedIn = new BehaviorSubject(this.hasToken());

  constructor(
    private router: Router,
    private http: HttpClient) { }

  getToken() {
    return localStorage.getItem(TOKEN_NAME);
  }

  setToken(token: string) {
    localStorage.setItem(TOKEN_NAME, token);
  }

  hasToken(): boolean {
    return !!this.getToken();
  }

  getTokenExpirationDate(token: string): Date {
    const decoded = jwt_decode(token);

    if (decoded.exp === undefined) { return null; }

    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
  }

  isTokenExpired(token?: string): boolean {
    if (!token) { token = this.getToken(); }
    if (!token) { return true; }

    const date = this.getTokenExpirationDate(token);
    if (date === undefined) { return false; }
    return !(date.valueOf() > new Date().valueOf());
  }

  authenticate(username: string, password: string) {

    const requestBody = `grant_type=password&username=${username}&password=${password}`;

    return this.http.post(environment.apiUrl + '/login', requestBody, {
      headers: this.httpHeaders
    })
      .map((response: any) => {
        if (response.access_token) {
          this.setToken(response.access_token);
          this.loggedIn.next(true);
        }
      });
  }

  isLoggedIn(): Observable<boolean> {
    return this.loggedIn.asObservable();
  }

  logout() {
    localStorage.removeItem(TOKEN_NAME);
    this.loggedIn.next(false);
    this.router.navigate(['/login']);
  }


  get httpHeaders(): HttpHeaders {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Cache-Control', 'no-cache');
    return headers;
  }

}
